/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../api-instance';
import { apiInstance } from '../api-instance';
import type {
  GetFoundryTableImportStatusPathParameters,
  ListFoundryWorkbookSheetsPathParameters,
  TLFoundryImportUploadAbortRequest,
  TLFoundryImportUploadAbortResponse,
  TLFoundryImportUploadCompleteRequest,
  TLFoundryImportUploadCompleteResponse,
  TLFoundryImportUploadInitiateRequest,
  TLFoundryImportUploadInitiateResponse,
  TLFoundryTableImportRequest,
  TLFoundryTableImportResponse,
  TLFoundryWorkbookSheetsResponse,
  TLHTTPValidationError,
  TLStreamFoundryImportUploadTableRequest,
} from './tessera-backend-api.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Create Foundry Table Import
 */
export const createFoundryTableImport = (
  tLFoundryTableImportRequest: BodyType<TLFoundryTableImportRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLFoundryTableImportResponse>(
    {
      url: `/foundry/table-imports`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLFoundryTableImportRequest,
      signal,
    },
    options,
  );
};

export const getCreateFoundryTableImportQueryKey = (
  tLFoundryTableImportRequest?: BodyType<TLFoundryTableImportRequest>,
) => {
  return ['POST', 'foundry', 'table-imports', tLFoundryTableImportRequest] as const;
};

export const getCreateFoundryTableImportQueryOptions = <
  TData = Awaited<ReturnType<typeof createFoundryTableImport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryTableImportRequest: BodyType<TLFoundryTableImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createFoundryTableImport>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCreateFoundryTableImportQueryKey(tLFoundryTableImportRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof createFoundryTableImport>>> = ({ signal }) =>
    createFoundryTableImport(tLFoundryTableImportRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof createFoundryTableImport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreateFoundryTableImportQueryResult = NonNullable<Awaited<ReturnType<typeof createFoundryTableImport>>>;
export type CreateFoundryTableImportQueryError = ErrorType<TLHTTPValidationError>;

export function useCreateFoundryTableImport<
  TData = Awaited<ReturnType<typeof createFoundryTableImport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryTableImportRequest: BodyType<TLFoundryTableImportRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof createFoundryTableImport>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createFoundryTableImport>>,
          TError,
          Awaited<ReturnType<typeof createFoundryTableImport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateFoundryTableImport<
  TData = Awaited<ReturnType<typeof createFoundryTableImport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryTableImportRequest: BodyType<TLFoundryTableImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createFoundryTableImport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createFoundryTableImport>>,
          TError,
          Awaited<ReturnType<typeof createFoundryTableImport>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateFoundryTableImport<
  TData = Awaited<ReturnType<typeof createFoundryTableImport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryTableImportRequest: BodyType<TLFoundryTableImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createFoundryTableImport>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create Foundry Table Import
 */

export function useCreateFoundryTableImport<
  TData = Awaited<ReturnType<typeof createFoundryTableImport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryTableImportRequest: BodyType<TLFoundryTableImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createFoundryTableImport>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCreateFoundryTableImportQueryOptions(tLFoundryTableImportRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Create Foundry Table Import
 */
export const prefetchCreateFoundryTableImportQuery = async <
  TData = Awaited<ReturnType<typeof createFoundryTableImport>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLFoundryTableImportRequest: BodyType<TLFoundryTableImportRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createFoundryTableImport>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getCreateFoundryTableImportQueryOptions(tLFoundryTableImportRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Create Foundry Table Import
 */
export const invalidateCreateFoundryTableImport = async (
  queryClient: QueryClient,
  tLFoundryTableImportRequest: BodyType<TLFoundryTableImportRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getCreateFoundryTableImportQueryKey(tLFoundryTableImportRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Abort Foundry Import Upload
 */
export const abortFoundryImportUpload = (
  tLFoundryImportUploadAbortRequest: BodyType<TLFoundryImportUploadAbortRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLFoundryImportUploadAbortResponse>(
    {
      url: `/foundry/table-imports/upload/abort`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLFoundryImportUploadAbortRequest,
      signal,
    },
    options,
  );
};

export const getAbortFoundryImportUploadQueryKey = (
  tLFoundryImportUploadAbortRequest?: BodyType<TLFoundryImportUploadAbortRequest>,
) => {
  return ['POST', 'foundry', 'table-imports', 'upload', 'abort', tLFoundryImportUploadAbortRequest] as const;
};

export const getAbortFoundryImportUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof abortFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadAbortRequest: BodyType<TLFoundryImportUploadAbortRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof abortFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAbortFoundryImportUploadQueryKey(tLFoundryImportUploadAbortRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof abortFoundryImportUpload>>> = ({ signal }) =>
    abortFoundryImportUpload(tLFoundryImportUploadAbortRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof abortFoundryImportUpload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AbortFoundryImportUploadQueryResult = NonNullable<Awaited<ReturnType<typeof abortFoundryImportUpload>>>;
export type AbortFoundryImportUploadQueryError = ErrorType<TLHTTPValidationError>;

export function useAbortFoundryImportUpload<
  TData = Awaited<ReturnType<typeof abortFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadAbortRequest: BodyType<TLFoundryImportUploadAbortRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof abortFoundryImportUpload>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof abortFoundryImportUpload>>,
          TError,
          Awaited<ReturnType<typeof abortFoundryImportUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAbortFoundryImportUpload<
  TData = Awaited<ReturnType<typeof abortFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadAbortRequest: BodyType<TLFoundryImportUploadAbortRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof abortFoundryImportUpload>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof abortFoundryImportUpload>>,
          TError,
          Awaited<ReturnType<typeof abortFoundryImportUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAbortFoundryImportUpload<
  TData = Awaited<ReturnType<typeof abortFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadAbortRequest: BodyType<TLFoundryImportUploadAbortRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof abortFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Abort Foundry Import Upload
 */

export function useAbortFoundryImportUpload<
  TData = Awaited<ReturnType<typeof abortFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadAbortRequest: BodyType<TLFoundryImportUploadAbortRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof abortFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAbortFoundryImportUploadQueryOptions(tLFoundryImportUploadAbortRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Abort Foundry Import Upload
 */
export const prefetchAbortFoundryImportUploadQuery = async <
  TData = Awaited<ReturnType<typeof abortFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLFoundryImportUploadAbortRequest: BodyType<TLFoundryImportUploadAbortRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof abortFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getAbortFoundryImportUploadQueryOptions(tLFoundryImportUploadAbortRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Abort Foundry Import Upload
 */
export const invalidateAbortFoundryImportUpload = async (
  queryClient: QueryClient,
  tLFoundryImportUploadAbortRequest: BodyType<TLFoundryImportUploadAbortRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getAbortFoundryImportUploadQueryKey(tLFoundryImportUploadAbortRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Complete Foundry Import Upload
 */
export const completeFoundryImportUpload = (
  tLFoundryImportUploadCompleteRequest: BodyType<TLFoundryImportUploadCompleteRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLFoundryImportUploadCompleteResponse>(
    {
      url: `/foundry/table-imports/upload/complete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLFoundryImportUploadCompleteRequest,
      signal,
    },
    options,
  );
};

export const getCompleteFoundryImportUploadQueryKey = (
  tLFoundryImportUploadCompleteRequest?: BodyType<TLFoundryImportUploadCompleteRequest>,
) => {
  return ['POST', 'foundry', 'table-imports', 'upload', 'complete', tLFoundryImportUploadCompleteRequest] as const;
};

export const getCompleteFoundryImportUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof completeFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadCompleteRequest: BodyType<TLFoundryImportUploadCompleteRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof completeFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCompleteFoundryImportUploadQueryKey(tLFoundryImportUploadCompleteRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof completeFoundryImportUpload>>> = ({ signal }) =>
    completeFoundryImportUpload(tLFoundryImportUploadCompleteRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof completeFoundryImportUpload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CompleteFoundryImportUploadQueryResult = NonNullable<
  Awaited<ReturnType<typeof completeFoundryImportUpload>>
>;
export type CompleteFoundryImportUploadQueryError = ErrorType<TLHTTPValidationError>;

export function useCompleteFoundryImportUpload<
  TData = Awaited<ReturnType<typeof completeFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadCompleteRequest: BodyType<TLFoundryImportUploadCompleteRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof completeFoundryImportUpload>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof completeFoundryImportUpload>>,
          TError,
          Awaited<ReturnType<typeof completeFoundryImportUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCompleteFoundryImportUpload<
  TData = Awaited<ReturnType<typeof completeFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadCompleteRequest: BodyType<TLFoundryImportUploadCompleteRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof completeFoundryImportUpload>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof completeFoundryImportUpload>>,
          TError,
          Awaited<ReturnType<typeof completeFoundryImportUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCompleteFoundryImportUpload<
  TData = Awaited<ReturnType<typeof completeFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadCompleteRequest: BodyType<TLFoundryImportUploadCompleteRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof completeFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Complete Foundry Import Upload
 */

export function useCompleteFoundryImportUpload<
  TData = Awaited<ReturnType<typeof completeFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadCompleteRequest: BodyType<TLFoundryImportUploadCompleteRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof completeFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCompleteFoundryImportUploadQueryOptions(tLFoundryImportUploadCompleteRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Complete Foundry Import Upload
 */
export const prefetchCompleteFoundryImportUploadQuery = async <
  TData = Awaited<ReturnType<typeof completeFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLFoundryImportUploadCompleteRequest: BodyType<TLFoundryImportUploadCompleteRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof completeFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getCompleteFoundryImportUploadQueryOptions(tLFoundryImportUploadCompleteRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Complete Foundry Import Upload
 */
export const invalidateCompleteFoundryImportUpload = async (
  queryClient: QueryClient,
  tLFoundryImportUploadCompleteRequest: BodyType<TLFoundryImportUploadCompleteRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getCompleteFoundryImportUploadQueryKey(tLFoundryImportUploadCompleteRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Initiate Foundry Import Upload
 */
export const initiateFoundryImportUpload = (
  tLFoundryImportUploadInitiateRequest: BodyType<TLFoundryImportUploadInitiateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLFoundryImportUploadInitiateResponse>(
    {
      url: `/foundry/table-imports/upload/init`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLFoundryImportUploadInitiateRequest,
      signal,
    },
    options,
  );
};

export const getInitiateFoundryImportUploadQueryKey = (
  tLFoundryImportUploadInitiateRequest?: BodyType<TLFoundryImportUploadInitiateRequest>,
) => {
  return ['POST', 'foundry', 'table-imports', 'upload', 'init', tLFoundryImportUploadInitiateRequest] as const;
};

export const getInitiateFoundryImportUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof initiateFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadInitiateRequest: BodyType<TLFoundryImportUploadInitiateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof initiateFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getInitiateFoundryImportUploadQueryKey(tLFoundryImportUploadInitiateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof initiateFoundryImportUpload>>> = ({ signal }) =>
    initiateFoundryImportUpload(tLFoundryImportUploadInitiateRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof initiateFoundryImportUpload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type InitiateFoundryImportUploadQueryResult = NonNullable<
  Awaited<ReturnType<typeof initiateFoundryImportUpload>>
>;
export type InitiateFoundryImportUploadQueryError = ErrorType<TLHTTPValidationError>;

export function useInitiateFoundryImportUpload<
  TData = Awaited<ReturnType<typeof initiateFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadInitiateRequest: BodyType<TLFoundryImportUploadInitiateRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof initiateFoundryImportUpload>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof initiateFoundryImportUpload>>,
          TError,
          Awaited<ReturnType<typeof initiateFoundryImportUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useInitiateFoundryImportUpload<
  TData = Awaited<ReturnType<typeof initiateFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadInitiateRequest: BodyType<TLFoundryImportUploadInitiateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof initiateFoundryImportUpload>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof initiateFoundryImportUpload>>,
          TError,
          Awaited<ReturnType<typeof initiateFoundryImportUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useInitiateFoundryImportUpload<
  TData = Awaited<ReturnType<typeof initiateFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadInitiateRequest: BodyType<TLFoundryImportUploadInitiateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof initiateFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Initiate Foundry Import Upload
 */

export function useInitiateFoundryImportUpload<
  TData = Awaited<ReturnType<typeof initiateFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLFoundryImportUploadInitiateRequest: BodyType<TLFoundryImportUploadInitiateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof initiateFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getInitiateFoundryImportUploadQueryOptions(tLFoundryImportUploadInitiateRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Initiate Foundry Import Upload
 */
export const prefetchInitiateFoundryImportUploadQuery = async <
  TData = Awaited<ReturnType<typeof initiateFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLFoundryImportUploadInitiateRequest: BodyType<TLFoundryImportUploadInitiateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof initiateFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getInitiateFoundryImportUploadQueryOptions(tLFoundryImportUploadInitiateRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Initiate Foundry Import Upload
 */
export const invalidateInitiateFoundryImportUpload = async (
  queryClient: QueryClient,
  tLFoundryImportUploadInitiateRequest: BodyType<TLFoundryImportUploadInitiateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getInitiateFoundryImportUploadQueryKey(tLFoundryImportUploadInitiateRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Stream Foundry Import Upload
 */
export const streamFoundryImportUpload = (
  tLStreamFoundryImportUploadTableRequest: BodyType<TLStreamFoundryImportUploadTableRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, tLStreamFoundryImportUploadTableRequest.file);

  return apiInstance<TLFoundryImportUploadCompleteResponse>(
    {
      url: `/foundry/table-imports/upload/stream`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getStreamFoundryImportUploadQueryKey = (
  tLStreamFoundryImportUploadTableRequest?: BodyType<TLStreamFoundryImportUploadTableRequest>,
) => {
  return ['POST', 'foundry', 'table-imports', 'upload', 'stream', tLStreamFoundryImportUploadTableRequest] as const;
};

export const getStreamFoundryImportUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof streamFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLStreamFoundryImportUploadTableRequest: BodyType<TLStreamFoundryImportUploadTableRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStreamFoundryImportUploadQueryKey(tLStreamFoundryImportUploadTableRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamFoundryImportUpload>>> = ({ signal }) =>
    streamFoundryImportUpload(tLStreamFoundryImportUploadTableRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof streamFoundryImportUpload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StreamFoundryImportUploadQueryResult = NonNullable<Awaited<ReturnType<typeof streamFoundryImportUpload>>>;
export type StreamFoundryImportUploadQueryError = ErrorType<TLHTTPValidationError>;

export function useStreamFoundryImportUpload<
  TData = Awaited<ReturnType<typeof streamFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLStreamFoundryImportUploadTableRequest: BodyType<TLStreamFoundryImportUploadTableRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamFoundryImportUpload>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamFoundryImportUpload>>,
          TError,
          Awaited<ReturnType<typeof streamFoundryImportUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useStreamFoundryImportUpload<
  TData = Awaited<ReturnType<typeof streamFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLStreamFoundryImportUploadTableRequest: BodyType<TLStreamFoundryImportUploadTableRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamFoundryImportUpload>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamFoundryImportUpload>>,
          TError,
          Awaited<ReturnType<typeof streamFoundryImportUpload>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useStreamFoundryImportUpload<
  TData = Awaited<ReturnType<typeof streamFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLStreamFoundryImportUploadTableRequest: BodyType<TLStreamFoundryImportUploadTableRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Stream Foundry Import Upload
 */

export function useStreamFoundryImportUpload<
  TData = Awaited<ReturnType<typeof streamFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLStreamFoundryImportUploadTableRequest: BodyType<TLStreamFoundryImportUploadTableRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getStreamFoundryImportUploadQueryOptions(tLStreamFoundryImportUploadTableRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Stream Foundry Import Upload
 */
export const prefetchStreamFoundryImportUploadQuery = async <
  TData = Awaited<ReturnType<typeof streamFoundryImportUpload>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLStreamFoundryImportUploadTableRequest: BodyType<TLStreamFoundryImportUploadTableRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamFoundryImportUpload>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getStreamFoundryImportUploadQueryOptions(tLStreamFoundryImportUploadTableRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Stream Foundry Import Upload
 */
export const invalidateStreamFoundryImportUpload = async (
  queryClient: QueryClient,
  tLStreamFoundryImportUploadTableRequest: BodyType<TLStreamFoundryImportUploadTableRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getStreamFoundryImportUploadQueryKey(tLStreamFoundryImportUploadTableRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary List Foundry Workbook Sheets
 */
export const listFoundryWorkbookSheets = (
  { programId }: ListFoundryWorkbookSheetsPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLFoundryWorkbookSheetsResponse>(
    { url: `/foundry/table-imports/workbooks/${programId}/sheets`, method: 'GET', signal },
    options,
  );
};

export const getListFoundryWorkbookSheetsQueryKey = ({ programId }: ListFoundryWorkbookSheetsPathParameters) => {
  return ['foundry', 'table-imports', 'workbooks', programId, 'sheets'] as const;
};

export const getListFoundryWorkbookSheetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listFoundryWorkbookSheets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { programId }: ListFoundryWorkbookSheetsPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFoundryWorkbookSheets>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFoundryWorkbookSheetsQueryKey({ programId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFoundryWorkbookSheets>>> = ({ signal }) =>
    listFoundryWorkbookSheets({ programId }, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: programId !== null && programId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listFoundryWorkbookSheets>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListFoundryWorkbookSheetsQueryResult = NonNullable<Awaited<ReturnType<typeof listFoundryWorkbookSheets>>>;
export type ListFoundryWorkbookSheetsQueryError = ErrorType<TLHTTPValidationError>;

export function useListFoundryWorkbookSheets<
  TData = Awaited<ReturnType<typeof listFoundryWorkbookSheets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListFoundryWorkbookSheetsPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFoundryWorkbookSheets>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFoundryWorkbookSheets>>,
          TError,
          Awaited<ReturnType<typeof listFoundryWorkbookSheets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFoundryWorkbookSheets<
  TData = Awaited<ReturnType<typeof listFoundryWorkbookSheets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListFoundryWorkbookSheetsPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFoundryWorkbookSheets>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFoundryWorkbookSheets>>,
          TError,
          Awaited<ReturnType<typeof listFoundryWorkbookSheets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListFoundryWorkbookSheets<
  TData = Awaited<ReturnType<typeof listFoundryWorkbookSheets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListFoundryWorkbookSheetsPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFoundryWorkbookSheets>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Foundry Workbook Sheets
 */

export function useListFoundryWorkbookSheets<
  TData = Awaited<ReturnType<typeof listFoundryWorkbookSheets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { programId }: ListFoundryWorkbookSheetsPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFoundryWorkbookSheets>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListFoundryWorkbookSheetsQueryOptions({ programId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Foundry Workbook Sheets
 */
export const prefetchListFoundryWorkbookSheetsQuery = async <
  TData = Awaited<ReturnType<typeof listFoundryWorkbookSheets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { programId }: ListFoundryWorkbookSheetsPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listFoundryWorkbookSheets>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListFoundryWorkbookSheetsQueryOptions({ programId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary List Foundry Workbook Sheets
 */
export const invalidateListFoundryWorkbookSheets = async (
  queryClient: QueryClient,
  { programId }: ListFoundryWorkbookSheetsPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListFoundryWorkbookSheetsQueryKey({ programId }) }, options);

  return queryClient;
};

/**
 * @summary Get Foundry Table Import Status
 */
export const getFoundryTableImportStatus = (
  { jobId }: GetFoundryTableImportStatusPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLFoundryTableImportResponse>(
    { url: `/foundry/table-imports/${jobId}`, method: 'GET', signal },
    options,
  );
};

export const getGetFoundryTableImportStatusQueryKey = ({ jobId }: GetFoundryTableImportStatusPathParameters) => {
  return ['foundry', 'table-imports', jobId] as const;
};

export const getGetFoundryTableImportStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getFoundryTableImportStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { jobId }: GetFoundryTableImportStatusPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoundryTableImportStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFoundryTableImportStatusQueryKey({ jobId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFoundryTableImportStatus>>> = ({ signal }) =>
    getFoundryTableImportStatus({ jobId }, requestOptions, signal);

  return { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFoundryTableImportStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFoundryTableImportStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFoundryTableImportStatus>>
>;
export type GetFoundryTableImportStatusQueryError = ErrorType<TLHTTPValidationError>;

export function useGetFoundryTableImportStatus<
  TData = Awaited<ReturnType<typeof getFoundryTableImportStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetFoundryTableImportStatusPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoundryTableImportStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFoundryTableImportStatus>>,
          TError,
          Awaited<ReturnType<typeof getFoundryTableImportStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFoundryTableImportStatus<
  TData = Awaited<ReturnType<typeof getFoundryTableImportStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetFoundryTableImportStatusPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoundryTableImportStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFoundryTableImportStatus>>,
          TError,
          Awaited<ReturnType<typeof getFoundryTableImportStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetFoundryTableImportStatus<
  TData = Awaited<ReturnType<typeof getFoundryTableImportStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetFoundryTableImportStatusPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoundryTableImportStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Foundry Table Import Status
 */

export function useGetFoundryTableImportStatus<
  TData = Awaited<ReturnType<typeof getFoundryTableImportStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { jobId }: GetFoundryTableImportStatusPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoundryTableImportStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFoundryTableImportStatusQueryOptions({ jobId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Foundry Table Import Status
 */
export const prefetchGetFoundryTableImportStatusQuery = async <
  TData = Awaited<ReturnType<typeof getFoundryTableImportStatus>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { jobId }: GetFoundryTableImportStatusPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFoundryTableImportStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetFoundryTableImportStatusQueryOptions({ jobId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Foundry Table Import Status
 */
export const invalidateGetFoundryTableImportStatus = async (
  queryClient: QueryClient,
  { jobId }: GetFoundryTableImportStatusPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetFoundryTableImportStatusQueryKey({ jobId }) }, options);

  return queryClient;
};
